/**
 *  登录  局部混入，仅需要的地方混入
 *  用于登录跳转
 *  
 */
import {
	mapActions,mapMutations
} from "vuex";

// cfmmc 第三方授权登录（OAuth2 授权码模式）
import { handleCfmmcSsoLogin, isCfmmcSsoQuery, getSsoQueryParams, briefErr } from "@/hooks/useCfmmcSso.js";
	
var loginMixin = {
	data() {
		return {
			
		}
	},
	computed:{
		// 公司信息
		configData(){
			let configData = this.$common.getConfigData() || {};
			return configData
		},
		
	},
	methods: {
		...mapActions({
			GETUserInfo: 'common/getUserInfo',
		}),
		...mapMutations({
			SETTkQuery: 'tk/setTkQuery',
			SETChooseFlight: 'tk/setChooseFlight',
			SETCxrList:"tk/setCxrList",
			SAVE_HOTELINFO: 'htCn/SAVE_HOTELINFO',
			SAVE_ROOMINFO: 'htCn/SAVE_ROOMINFO',
			SET_HTCN_QUERY: 'htCn/SET_HTCN_QUERY',
			SET_HTCN_POLICY: 'htCn/SET_HTCN_POLICY',
			SAVE_NIGHT_ROOMS: 'htCn/SAVE_NIGHT_ROOMS',
			SAVE_ISFREEMEAl: 'htCn/SAVE_ISFREEMEAl',
			SET_HTCN_CCSQD: 'htCn/SET_HTCN_CCSQD', //保存因共模式下的出差申请单信息
			SET_HT_CXR_LIST: 'htCn/SET_CXR_LIST',
			SAVE_DESCRIPTION: 'htCn/SAVE_DESCRIPTION',
			SAVE_ROOMS: 'htCn/SAVE_ROOMS',
			SET_HTCN_PARAMS: 'htCn/SET_HTCN_PARAMS'
		}),
		// 钉钉授权登录
		DingDingLogin(req,successFn,errorFn){
	
			if (dd.env.platform != 'notInDingTalk') {
				dd.ready(()=> {
					dd.runtime.permission.requestAuthCode({
						corpId: req.corpId, // 企业id
						onSuccess: (info)=> {
							req.code = info.code; // 通过该免登授权码可以获取用户身份
					
							var queryForDingDing = {
								corpNo: req.corpNo,
								code: req.code
							}
							this.toDingDingLoginAjax(queryForDingDing, req,successFn,errorFn);
						},
						onError: (err)=> {
							
							successFn && successFn(false)
							this.$alert(JSON.stringify(err),'钉钉登录失败',{
								type:'error',
							})
							
						}
					});
				});
			} else {
				console.log('该程序未在钉钉内部打开')
				errorFn&&errorFn('该程序未在钉钉内部打开')
			}

		},
		//天润+壳牌+标准单点登录 需要调用登录接口
		standardSSO(req,successFn,errorFn) {
			var param = {};
			if(req.loginType == 10) { //标准sso  + 天润新能 + 壳牌石油
				if(this.$common.ifStrBlank(req.ssotoken, 32)) {
					throw "-1|token失效！";
				} else {
					param.loginName = req.ssotoken;
					param.password = req.ssotoken;
					param.loginType = 10;
				}
			} else if(req.loginType == 12) { //金风科技，从ve过来
				if(this.$common.ifStrBlank(req.hyid, 32) || this.$common.ifStrBlank(req.sign, 32)) { //没有传会员id
					throw "-1|token失效！";
				} else {
					param.corpId = req.hyid;
					param.loginName = req.zcm;
					param.password = req.sign;
					param.loginType = 12;
				}
			}
		
			this.toSsoLoginAjax(param, req,successFn,errorFn);
		},
		// 中铁单点登录  无需登录，仅需要刷新token
		crecgSSO(req,successFn,errorFn) { //中国中铁单点登录||obj.searchType
				if(common.ifStrBlank(req.token, 32)) {
					throw "-1|token失效";
				}
				this.$common.sessionset('access_token', req.token);
				this.$common.localset('access_token', req.token);
				this.getUserInfo({"refresh": "1"},req,successFn,errorFn);
						
		},
		// 单点登录接口  调用 1.0.0 接口
		toSsoLoginAjax(param,req,successFn,errorFn){
			var urlStr = 'user.ssologin';
			this.$conn.getConn(urlStr)(param,(res)=>{
				var data = res.data || {};
				let token = data.token || data;
				if (token) {
					this.$common.sessionset('access_token', token);
					this.$common.localset('access_token', token);
					// 获取用户详情
					this.getUserInfo({},req,successFn,errorFn);
				}
			},(err)=>{
				errorFn&&errorFn(err)
			})
		},

		// 登录接口2025版 
		/**
		 * 	【2025登录】
		 *  【登录方式】 支持：  
		 * 		a. 企业账号 + 工号/手机号 + 密码
		 *      b. 手机号 + 验证码
		 *      c. 手机号 + 密码
		 * 
		 * **/ 
		toLoginAjax(queryObj,req,successFn,errorFn) {
		
			let timestamp = new Date().getTime();
			let password = this.$common.md5PassWord(queryObj.password,timestamp)
			let queryObjFor2025 = {
				"loginType": queryObj.loginType, // 登录类型，1工号+密码登录；2手机+验证码登录；3手机号+密码登录 ,
				"timestamp": timestamp, // 时间戳；必填 ,
			}
			if(queryObj.loginType == 1){ // 登录类型，1: 工号+密码登录
				queryObjFor2025.userCode = {
					"corpNo": queryObj.corpNo,
					"empNo": queryObj.loginName,
					"password": password,
				}
			}
			if(queryObj.loginType == 2){  // 2: 手机+验证码登录
				queryObjFor2025.userPhone = {
					"compId": queryObj.compId,
					// "password": password,
					"phone": queryObj.loginName,
					"verifyCode": queryObj.password
				}
			}
			if(queryObj.loginType == 3){  // 3: 手机号+密码登录
				queryObjFor2025.userPhone = {
					"compId": queryObj.compId,
					"password": password,
					"phone": queryObj.loginName,
					// "verifyCode": queryObj.password
				}
			}
		
			var urlStr = "user.empLogin";
			this.$conn.getConn(urlStr)(queryObjFor2025,(res)=>{
				var data = res.data || {};
				let token = data.token;
				/**
				 *  如果status=1，直接按正常流程执行
					如果status≠1，弹出提示框，内容为 status 
						点击确认之后，
						再判断weakpwd，
							weakpwd=1 跳转到修改密码；
							weakpwd=0，再判断verify，
								verify=1，自动切换到手机号+验证码
				 * 
				 * 
				 * **/ 
				// 登录结果：1成功，其他值为错误说明
				if(data.status == 1){
					if (token) {
						this.$common.sessionset('access_token', token);
						this.$common.localset('access_token', token);
	
						let loginObj = {
							...data,
							// weakpwd :1,
						}
						// 获取用户详情
						this.getUserInfo({},req,successFn,errorFn,loginObj);
					}else{
						successFn && successFn(false)
						this.$alert('登录失败' ,'温馨提示',{
							type:'error',
						})
					}
				}else{
					if (token) {
						this.$common.sessionset('access_token', token);
						this.$common.localset('access_token', token);
					}
					this.$alert(data.status ,'温馨提示',{
						type:'error',
						confirmButtonText: '确定',
						callback: action => {

							successFn && successFn(false)
							if(data.weakpwd == 1){
								this.$router.replace({
									path: "forgetPassword",
									query:{
										type:2, // 重置密码
									}
									
								})
							}else{
								if(data.verify == 1){
									successFn && successFn(false,data)
								}
							}
						}
					})
					// if(loginObj && loginObj.weakpwd == 1){
					// 	this.$confirm('系统检测到您当前的密码等级【较低】；建议您修改后，再进行操作！', '温馨提醒', {
					// 		confirmButtonText: '修改密码',
					// 		cancelButtonText: '下次修改',
					// 		type: 'warning'
					// 	}).then(() => {
					// 			this.$router.replace({
					// 				path: "yjTravel/myTravel/userCenter/personCenter"
					// 			})
					// 	}).catch(() => {
					// 			this.$router.replace({
					// 				path: pathMap['home'],
					// 			})             
					// 	});

					// 	return
						
					// }
				}





			},(err)=>{
				errorFn&&errorFn(err)
			})
		},
		
		// // 登录接口  1.1.0 接口
		// toLoginAjax(param,req,successFn,errorFn){
		// 	var urlStr = 'user.login';
		// 	this.$conn.getConn(urlStr)(param,(res)=>{
		// 		var data = res.data || {};
		// 		let token = data.token;
		// 		if (token) {
		// 			this.$common.sessionset('access_token', token);
		// 			this.$common.localset('access_token', token);
		// 			// 获取用户详情
		// 			this.getUserInfo({},req,successFn,errorFn);
		// 		}else{
		// 			successFn && successFn(false)
		// 			this.$alert(data.msg,'',{
		// 				type:'error',
		// 			})
		// 		}
		// 	},(err)=>{
		// 		errorFn&&errorFn(err)
		// 	})
		// },
		// 钉钉登录接口
		toDingDingLoginAjax(param,req,successFn,errorFn){
			var urlStr = 'user.dingtalkLogin';
			this.$conn.getConn(urlStr)(param,(res)=>{
				var data = res.data || {};
				let token = data.token || data;
				if (token) {
					this.$common.sessionset('access_token', token);
					this.$common.localset('access_token', token);
					// 获取用户详情
					this.getUserInfo({},req,successFn,errorFn);
				}
			},(err)=>{
				errorFn&&errorFn(err)
			})
		},

		// 切换登录
		reLogin(param,successFn,errorFn){
			
			let queryString = {
				"corpId": param.corpId,
				"deptId": param.deptId,
			};
			let queryUrl = 'user.reLogin'
			this.$conn.getConn(queryUrl)(queryString,(res)=>{
				let token = res.data || '';
				if (token) {

					this.$common.sessionclear();
					this.$common.localremove('tmpaccess')
					this.clearLocalStorage();
					this.$initVuex.vuexCache();

					this.$common.sessionset('access_token', token);
					this.$common.localset('access_token', token);
					// 获取用户详情  
					this.getUserInfo({},{},successFn,errorFn);
				}

			},(err)=>{
				errorFn && errorFn(err);
				this.$message({
					type: 'error',
					message: err.tips
				})
			})
		},
		// 清楚本地缓存
		clearLocalStorage(){
			let arrList = ['chooseCcsqdObj','curHotel','cxrListMapForHistory','tmcLoginInfo','user_info','hotel'];
			
			for(let key in arrList){
				this.$common.localremove(arrList[key])
			}
			
			
			
		},

		// 获取用户详情
		getUserInfo(userInfoParam,req,successFn,errorFn,loginObj){
			
			let vm = this;
			this.GETUserInfo({
				vm,
				param:userInfoParam || {},
				cb: (data) => {
					successFn&&successFn(data);
					this.goToHomePath(req,loginObj)
				},
				errorCb:(err)=>{
					errorFn&&errorFn(err)
				}
			})
		},
		// 跳转路由
		goToHomePath(obj,loginObj) {
			
			obj = obj || {};

			let status = obj.status || {};

			obj.searchType = this.$common.trimToEmtry(obj.searchType, "home");
			obj.approvalNo = this.$common.trimToEmtry(obj.approvalNo || '');
			obj.tripType = this.$common.trimToEmtry(obj.tripType || '');
			obj.orderNo = this.$common.trimToEmtry(obj.orderNo || '');
			obj.orderType = this.$common.trimToEmtry(obj.orderType || '');

			status.workItemId   = this.$common.trimToEmtry(status.workItemId || obj.workItemId   || ''); // 优先取 status 里的工作项  具体参考 h5
			status.needApprove   = this.$common.trimToEmtry(status.needApprove || obj.needApprove   || ''); //  1: 需要操作审批，2：无需操作审批
			// 出差申请单 1标准版 2定制版
			let ccsqdType = 1;
			ccsqdType =  this.$common.getVipParamterByParNo(this.$store,20033, 1)
			var pathMap = {
				'home': '/yjTravel/home', //默认首页
				'flightList': '/yjTravel/book/tkRouter/tkQuery', //机票
				'hotelList': "/yjTravel/book/htCnRouter/htCnQuery", //酒店
				'trainList': "/yjTravel/book/trRouter/trQuery", //火车票
				'MyOrder': "/yjTravel/myTravel/userCenter/order", //我的订单
				'trainRefundTicket': '/yjEdit/trainRefund' , //（火车票 退入口）
				'trainChangeTicket': '/yjEdit/trainChange',  //（火车票 改入口）
				'hotelRefund': '/yjDetail/htRefundRooms',  //（酒店订单 退订入口）
				'flightRefundTicket': '/yjEdit/tkRefund',  //（机票 退入口）
				'flightChangeTicket': '/yjEdit/tkChange' , //（机票 改签入口）
				'hotelDetail': this.getPathUrl(obj.orderType,obj.orderNo) || '/yjDetail/htCnOrderDetail',  //（酒店详）
				'flightDetail': this.getPathUrl(obj.orderType,obj.orderNo) || '/yjDetail/tkOrderDetail' , //（机票详）
				'trainDetail': this.getPathUrl(obj.orderType,obj.orderNo) || '/yjDetail/trainDetail',  //（火车票详）

				'hotelDetailSp': this.getPathUrl(obj.orderType,obj.orderNo) || '/yjDetail/htCnOrderDetail',  //（酒店详）
				'flightDetailSp': this.getPathUrl(obj.orderType,obj.orderNo) || '/yjDetail/tkOrderDetail' , //（机票详）
				'trainDetailSp': this.getPathUrl(obj.orderType,obj.orderNo) || '/yjDetail/trainDetail',  //（火车票详）

				'htInterNeed': '/yjTravel/book/inHtRouter/inHtEdit' , //（国际酒店需求单）
				'tkInterNeed': '/yjTravel/book/inTkRouter/inTkEdit',  //（国际机票需求单）
				'carDetail':'/yjDetail/carDetail',  //（用车订单详情）
				'travelDetail':ccsqdType == 1?'/ccsqdDetail':'/xakCcsqdDetail',  //（出差申请单详情）

				'travelDetailSp':ccsqdType == 1?'/ccsqdDetail':'/xakCcsqdDetail',  //（出差申请单详情审批）

				'travelAppList':'/yjTravel/myTravel/userCenter/needMyApproval', // 审批列表

				'planeBook':'/yjEdit/tkEdit', // 机票填写页
				'trainBook':'/yjEdit/trEdit', // 火车填写页
				'hotelBook':'/yjTravel/book/htCnRouter/htCnQuery', // 酒店填写页
			}
			this.$common.sessionset('ssoLogin',obj);
			var path = pathMap[obj.searchType];
			if (path) {
				let appType ;
				if(obj.searchType == 'hotelDetailSp' || obj.searchType == 'trainDetailSp' || obj.searchType == 'flightDetailSp' || obj.searchType == 'travelDetailSp'){
					appType = status.needApprove || 1;
				}
				// 机票填写页处理
				if(obj.searchType == 'planeBook' ){
					if(obj.status.policyId){
						this.initTkEditInfo(obj,(resdata)=>{
							this.$router.replace({
								path: path,
								query: {
									ccsqdId: obj.approvalNo || undefined,
									tripType: obj.tripType || undefined,
									orderId: obj.orderNo || obj.approvalNo  || undefined,
									orderType:obj.orderType || undefined,
									workItemId  :status.workItemId   || undefined,
									appType:appType,
									
								}
							})
						})
						return 
					}else{
						// 没有政策id跳转至 航班查询页
						path = pathMap['flightList'];
					}

				}

				// 酒店填写页处理
				if(obj.searchType == 'hotelBook'){
					this.initHtEditInfo(obj, (resdata)=>{
						this.$router.replace({
							path: path,
							query: resdata
						})
					})
					return;
				}

				this.$router.replace({
					path: path,
					query: {
						ccsqdId: obj.approvalNo || undefined,
						tripType: obj.tripType || undefined,
						orderId: obj.orderNo || obj.approvalNo  || undefined,
						orderType:obj.orderType || undefined,
						workItemId  :status.workItemId   || undefined,
						appType:appType,
						timestamp:new Date().getTime(),
					}
				})
			} else {
				
				if(loginObj && loginObj.weakpwd == 1){
					this.$confirm('系统检测到您当前的密码等级【较低】；建议您修改后，再进行操作！', '温馨提醒', {
						confirmButtonText: '修改密码',
						cancelButtonText: '下次修改',
						type: 'warning'
					}).then(() => {
							this.$router.replace({
								path: "yjTravel/myTravel/userCenter/personCenter"
							})
					}).catch(() => {
							this.$router.replace({
								path: pathMap['home'],
							})             
					});
					
				}else{
					this.$router.replace({
						path: pathMap['home'],
					})
				}


			}
			// 跳转后，获取详情，有延时
			// this.getCcsqdDetailByCcsqdIdOrNo()
		},

		
		// 登陆成功，跳转地址 订单详情
		getPathUrl(orderType,orderNo){
			let pathUrl = '';
			if(orderType){
				pathUrl =  this.$dict.detailConfig(orderType)
			}else if(orderNo){
				let shortOrderNo =  orderNo.substr(0,2);
				pathUrl = this.$dict.detailConfigByChat(shortOrderNo)
			}
			return pathUrl
		
		},
		
		// 获取单点登录信息
		getSsoLogin(){
			this.isShowLoginPage = false;
			var routeParamObj = this.$common.getParams() || {};

			// 兼容 hash 路由（#/login?code=xxx）上的参数：第三方授权回跳可能把参数拼在 # 后面
			Object.assign(routeParamObj, getSsoQueryParams());
			
			if(routeParamObj.status){
				try{
					routeParamObj.status = decodeURIComponent(routeParamObj.status)
				}catch(e){}
			}
			
			// 处理 个性化企业单点标识
			if (routeParamObj.status && this.$common.isJsonString(routeParamObj.status)) {
				routeParamObj.status = JSON.parse(routeParamObj.status) || {};
			}else{
				routeParamObj.status = {};
			}
			this.$common.localset('chooseCcsqdObj',{})
			this.$initVuex.vuexCache();

			this.$common.sessionset('reqParams',routeParamObj);

			// 【0】有 err 参数直接判定登录异常
			if(this.$common.ifStrNotBlank(routeParamObj['err'])){
				this.$alert('登录异常，请重新登录！','登录失败',{
					type:"error"
				})
				this.isShowLoginPage = true;
				return;
			}

			// 【1】cfmmc 第三方授权登录：loginType == 13，或 code 与 state 同时存在
			if(isCfmmcSsoQuery(routeParamObj)){
				this.$common.sessionremove('access_token');
				this.$common.localremove('access_token');
				this.cfmmcSsoLogin(routeParamObj,(res)=>{

				},(err)=>{
					this.$alert(briefErr(err),'授权登录失败',{
						type:"error"
					})
					this.isShowLoginPage = true;
				})
				return;
			}

			 if(routeParamObj['loginType']){// 【2】 从第三方web网站单点过来  // 天润+壳牌+标准单点登录
				this.$common.sessionremove('access_token');
				this.$common.localremove('access_token');
				// 方法来自于 loginMixin
				this.standardSSO(routeParamObj,(res)=>{
					
				},(err)=>{
					this.$alert(err.tips,'登录失败',{
						type:"error"
					})
					this.isShowLoginPage = true;
				})
			}else if(routeParamObj['corpId']){ //【3】钉钉单点登录
				this.$common.sessionremove('access_token');
				this.$common.localremove('access_token');
				// 方法来自于 loginMixin
				this.DingDingLogin(routeParamObj,(res)=>{
					
				},(err)=>{
					this.$alert(err.tips,'登录失败',{
						type:"error"
					})
					this.isShowLoginPage = true;
				})

			} else if(routeParamObj['searchType']){ // 【4】 从第三方web网站单点过来 //中国中铁
				this.$common.sessionremove('access_token');
				this.$common.localremove('access_token');
				// 方法来自于 loginMixin
				this.crecgSSO(routeParamObj,(res)=>{
					
				},(err)=>{
					this.$alert(err.tips,'登录失败',{
						type:"error"
					})
					this.isShowLoginPage = true;
				})
				// 【5】： 从etsmsweb 管理端单点过来的，此时token 为共用的
				// window.location.href.indexOf('refresh')> -1
				// routeParamObj['refresh'] == 1
			}else if(window.location.href.indexOf('refresh')> -1){
				if(this.$common.sessionget('access_token')){
					// 方法来自于 loginMixin
					this.getUserInfo({},{},(res)=>{
						
					},(err)=>{
						this.$alert(err.tips,'登录失败',{
						type:"error"
					})
						this.isShowLoginPage = true;
					})
				}else{
					this.isShowLoginPage = true;
				}
				
			}else{ // 否则正常登录
				this.isShowLoginPage = true;
			}
			
			
		},
		
		// cfmmc 第三方授权登录：已带 code&state 则换 token，否则跳转第三方授权页
		async cfmmcSsoLogin(req,successFn,errorFn){
			try {
				const finished = await handleCfmmcSsoLogin({
					loginType: req.loginType,
					code: req.code,
					state: req.state,
				});

				// 跳转第三方后页面即将离开，返回 false 不做后续处理
				if(finished){
					// token 已就绪，继续走普通登录成功流程
					this.getUserInfo({"refresh": "1"},req,successFn,errorFn);
				}
			} catch (err) {
				errorFn && errorFn(err);
			}
		},


		// 根据出差单号或者id，获取出差单详情
		getCcsqdDetailByCcsqdIdOrNo(){
			var reqParams = this.$common.sessionget('reqParams') || {};
			if(!reqParams.approvalNo){
				return false
			}
			let obj = {
				ccsqdId:reqParams.approvalNo
			}
			this.$conn.getConn('travelRequest.travelRequestInfo')(obj,(res)=>{
				
				var ccsqdDetail = res.data || {};
				var ccsqdId = ccsqdDetail.id || reqParams.approvalNo;
			
				this.chuLiRouteByCcsqd(ccsqdId,ccsqdDetail)
			},(err)=>{
				
			})	
				
		},
		/**
		 *  let obj = {
					cxrList: [], //出行人列表
					detail: {}, //出差申请单信息
					proType: this.proType,
					currentRoute: {, //多选行程中的其中一项
					routeId: '', //出行id
					ccsqdNo:'',
					ccsqdId:'',
				}
		 ***/ 
		// 处理出差行程问题
		chuLiRouteByCcsqd(ccsqdId, ccsqdDetail, proType, callback) {
			var reqParams = this.$common.sessionget('reqParams') || {};
			var obj = {}; // 定义ccsqdObj
			obj.ccsqdId = ccsqdId;
			obj.ccsqdNo = ccsqdDetail.ccsqdNo;
			obj.detail = ccsqdDetail;
			obj.proType = proType || '';
			obj.cxrList = [];
			
			var routeObj = {}; // 指定行程详情
			var routeList = ccsqdDetail.allRouteList || [];
		
			//  默认取  如果有行程的，取改行程的行程！
			for (var k = 0; k < routeList.length; k++) {
				var routeItem = routeList[k][0] || {};
				if (routeItem.routeId == reqParams.routeId) {
					obj.routeId = reqParams.routeId;
					routeObj = routeItem;
					break;
				}
			}
		
			// 否则  如果没有行程id  取该产品 第一条行程
			if (!this.$common.isObjNotBlank(routeObj)) {
				for (var k = 0; k < routeList.length; k++) {
					for (var i = 0; i < routeList[k].length; i++) {
						var routeItem = routeList[k][i] || {};
						if (routeItem['proType'] == proType || routeItem['proType'] == '---') {
							obj.routeId = routeItem.routeId;
							routeObj = routeItem;
		
							break;
						}
					}
					if (i != routeList[k].length) {
						break;
					}
		
		
				}
			}
		
		
			ccsqdDetail.currentRoute = routeObj;
			
		
			var zongPeopleList = ccsqdDetail.personList || [];
			// 存储出行人
			var cxrIdArr = routeObj.cxrId ? routeObj.cxrId.split(',') : [];
			var cxrArr = routeObj.cxr ? routeObj.cxr.split(',') : [];

			var newList = [];
		
			for (var i = 0; i < zongPeopleList.length; i++) {
				var isAdd = false;
				zongPeopleList[i]['choosed'] = true;
				var peopleItem = zongPeopleList[i];
				peopleItem['cxrType'] = zongPeopleList[i]['exPerson'] == 1 ? '2' : '1';
				peopleItem['idcardList'] = peopleItem.vipIdcardResponses || [];
		
				ccsqdDetail.costCenter = ccsqdDetail.costCenter || [];
				for (var j = 0; j < ccsqdDetail.costCenter.length; j++) {
					var cost = ccsqdDetail.costCenter[j] || {};
					if (cost.costId == peopleItem.costId) {
						peopleItem.costCenterCode = cost.costCenterCode || ''; // 成本中心代码 ,
						peopleItem.costCenterId = cost.costId || ''; // 成本中心id ,
						peopleItem.costCenterName = cost.costCenterName || ''; // 成本中心名称 ,
						break;
					}
				}
		
				if (!peopleItem.costCenterId) {
					peopleItem.costCenterCode = ccsqdDetail.costCenterCode || ''; // 成本中心代码 ,
					peopleItem.costCenterId = ccsqdDetail.costCenterId || ''; // 成本中心id ,
					peopleItem.costCenterName = ccsqdDetail.costCenterName || ''; // 成本中心名称 ,
				}
		
				for (var k = 0; k < cxrArr.length; k++) {
					if (peopleItem['empId'] == cxrIdArr[k] && peopleItem['cxrName'] == cxrArr[k]) {
						isAdd = true;
						break;
					}
				}
		
				for (var j = 0; j < newList.length; j++) {
					if (newList[j]['empId'] == peopleItem['empId'] && newList[j]['cxrName'] == peopleItem['cxrName']) {
						isAdd = false;
						break;
		
					}
				}
				// 如果人员不可选择，则不选择
				if(peopleItem.canChoose != 1){
					isAdd = false;
				}
				
				if (isAdd) {
					newList.push(peopleItem)
				}
		
			}
		
		
			obj.cxrList = newList;
			let chooseCcsqdObj = this.$common.localget('chooseCcsqdObj')||{}
			chooseCcsqdObj[proType]= obj
			this.$common.localset('chooseCcsqdObj',chooseCcsqdObj)
		},
		
		
		// 处理单点跳转机票填写页时的机票信息
		initTkEditInfo(obj,callback){
			
			// policyId  
			// 'tmc_plane_ow_flight_B2G:CSXBJS20260729_a969e1f5a2154a10b0fed375327361cf_202607291435·IBE_HU723620260729_Q_0_PEK483_1910_2914·-1·1·-1·-1'
			let policyId = obj.status.policyId ;
			let queryString = {
				policyId: policyId,
			}
			
			this.$conn.getConn('tkQuery2023.queryFlightCabin3')(queryString,(res)=>{
				
				let data = res.data || {};
				let cacheId = data.cacheId || '';
				let flight = data.flight || {};
				flight.cacheId = cacheId;

				let price = data.price || {};
				let cabin = data.cabin || {} ;
	
				// SETTkQuery: 'tk/setTkQuery',
				// SETChooseFlight: 'tk/setChooseFlight',
				// SETCxrList:"tk/setCxrList",
				this.SETTkQuery({
					tripType:data.tripType || obj.tripType || 1,
					travelType :data.travelType  || 1,
				})

				let user_info = this.$common.localget('user_info') || {};
				user_info.empInfo = user_info.empInfo || {};
				user_info.empInfo.cxrName = user_info.empInfo.empName || '';
				let cxrList = [user_info.empInfo || {}]

				this.SETCxrList(cxrList)

				this.SETChooseFlight({
					...flight,
					chooseCabin:{
						...cabin,
						...price
					}
				})
				callback && callback (data)
				
			},(err)=>{
				
				this.$alert(err.tips,'机票价格失效',{
					type:'error',
				})
				this.isShowLoginPage = true;
			})
		},

		// 处理酒店订单填写
		initHtEditInfo(query) {
			let status = query ? query.status : {}
			let hotelId = status.hotelId || '';
			let checkInDate = status.checkInDate || '';
			let checkOutDate = status.checkOutDate || '';
			
			let user_info = this.$common.localget('user_info') || {};
			let empInfo = user_info.empInfo || {};
			let cxrList = [empInfo]

			this.SET_HTCN_QUERY({
				tripType: query.tripType || 1,
				empRank: empInfo.empRank,
				useNameclbz: empInfo.empName,
			})
			
			this.SET_HTCN_PARAMS({
				checkInDate,
				checkOutDate,
				// cityId: hotelDetailBean.cityId
			})

			this.SAVE_ROOMS(1)
			this.SET_HT_CXR_LIST(cxrList)

			let item = {};
			item.checkInDate = checkInDate
			item.checkOutDate = checkOutDate
			let hotelItem = {
				checkInDate,
				checkOutDate,
				jdid: hotelId,
				// cityId: this.htCnParams.cityId
			}
			this.SAVE_HOTELINFO(item)
			this.$router.push({
				path: '/yjTravel/book/htCnRouter/HtCnDetails',
				query: hotelItem,
			})

			// let status = query ? query.status : {}
			// // TODO:  需要从单点status里面获取需要的参数 暂时先写死
			// // || '0076c3b2bc0ba42357c2118794936346'
			// let ratePlanId = status.ratePlanId;
			// this.$conn.getConn('htbook.hotelDataValidate2')({ ratePlanId }).then((res) => {
			// 	let data = res.data || {};
			// 	// 酒店信息
			// 	let hotelDetailBean = data.hotelDetailBean || {};
			// 	// 房间信息
			// 	let roomBean = data.roomBean || {};
			// 	// 价格计划信息
			// 	let hotelRatePlan = data.hotelRatePlan || {};
			// 	this.SAVE_ROOMINFO({
			// 		...roomBean,
			// 		resRoomInfo: roomBean,
			// 	})
			// 	this.SAVE_HOTELINFO(hotelDetailBean)

			// 	this.SAVE_ISFREEMEAl(hotelRatePlan?.freeMeal ?? 0)
			// 	this.SAVE_NIGHT_ROOMS(hotelRatePlan?.nightlyRates ?? [])
			// 	this.SAVE_DESCRIPTION(hotelRatePlan.prepayRule?.description ?? '暂无取消规则！')

			// 	let user_info = this.$common.localget('user_info') || {};
			// 	let empInfo = user_info.empInfo || {};
			// 	let cxrList = [empInfo]

			// 	this.SET_HTCN_QUERY({
			// 		empRank: empInfo.empRank,
			// 		useNameclbz: empInfo.empName,
			// 	})
				
			// 	this.SET_HTCN_PARAMS({
			// 		checkInDate: data.checkInDate,
			// 		checkOutDate: data.checkOutDate,
			// 		cityId: hotelDetailBean.cityId
			// 	})

			// 	this.SAVE_ROOMS(1)
			// 	this.SET_HT_CXR_LIST(cxrList)

			// 	let obj = {
			// 		checkInDate: data.checkInDate,
			// 		checkOutDate: data.checkOutDate,
			// 		jdid: hotelDetailBean.jdid,
			// 		roomId: hotelRatePlan.roomId,
			// 		payment: hotelRatePlan.payment,
			// 		ratePlanId: hotelRatePlan.ratePlanId,
			// 		fyid: hotelRatePlan.fyid,
			// 		hotelId: hotelDetailBean.jdid,
			// 		bussType: hotelRatePlan.bussType,
			// 	}
			// 	this.$router.push({
			// 		name: 'HtCnEdit',
			// 		query: obj,
			// 	})		
		},
		// 初始化页面风格
		initPageSet(){
			let oldData =   this.configData;
			let newData = {
					compaySuper: this.configData.compId,
					corpId: '',
					corpName: this.configData.corpFullName,
					corpNo: '',
					domainName: this.configData.apiurl,
					etBrowserLogo: this.configData.logoImg || this.configData.defaultLogoImg,
					etBrowserName: this.configData.corpName,
					etCopyrightInformation: this.configData.icp,
					etServicePhone: this.configData.officalPhone,
					id: '',
					logoUrl: this.configData.logoImg || this.configData.defaultLogoImg,
					pageName: this.configData.corpName,
					qrCode: '',
					carouselPictures: [],
					serverPictures: [],
					tSysStyle: 1,
			};
			
			this.compInfo ={
				...oldData,
				...newData
			}
			this.$common.sessionset('pageSettingInfo',this.compInfo)
		},
		
		
		/**
		 *  获取页面风格配置
		 *
		 **/ 
		// 获取登录页面风格
		getEtPageSetList(){
			var hostName = window.location.hostname;  //域名
			let queryString = {}
				queryString = {
						compaySuper:this.configData.compId,
						domainName: hostName, //'39.106.172.100' 测试时用, hostName
						sysType: "etsmsobt"
					}
			this.$conn.getConn('commu.etPageSetList')(queryString,(res)=>{
				let data = res.data || {};
				this.getCompaySuper(data);
				
				
			},(err)=>{
				this.getCompaySuper();
				// this.$message.error(err.errMsg)
			})
			
		},
		// 设置页面登录风格
		getCompaySuper(data){
			if(data.compaySuper){
				this.compInfo = {
					compaySuper: data.compaySuper,
					corpId: data.corpId,
					corpName: data.corpName,
					corpNo: data.corpNo,
					domainName: data.domainName,
					etBrowserLogo: data.etBrowserLogo,
					etBrowserName: data.etBrowserName,
					etCopyrightInformation: data.etCopyrightInformation || this.configData.icp, //暂时给个备案号
					etServicePhone: data.etServicePhone,
					id: data.id,
					logoUrl: data.logoUrl,
					pageName: data.pageName,
					qrCode: data.qrCode,
					carouselPictures: data.carouselPictures,
					serverPictures: data.serverPictures,
					tSysStyle: data.tSysStyle,
				}
			}else{
				this.initPageSet();	
			}
			this.$common.sessionset('pageSettingInfo',this.compInfo)
			//默认修改标题
			this.$common.changeTitle(this.compInfo.etBrowserName);
			if( this.compInfo.etBrowserLogo){
				document.querySelector('link[rel*="icon"]').href = this.compInfo.etBrowserLogo || '';
			}
		},
		
		
		
	}

}


export default loginMixin
